"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const Rebase_1 = __importDefault(require("./Rebase"));
class Policy {
    constructor(data) {
        this.data = data;
        this.historicalRebases = [];
        this.lastRebase = new Rebase_1.default(this.data.lastRebase);
        if (this.data.historicalRebases) {
            this.loadHistoricalRebases(this.data.historicalRebases.map((r) => new Rebase_1.default(r)));
        }
    }
    get address() {
        return this.data.id;
    }
    get epoch() {
        return this.lastRebase.epoch;
    }
    get supply() {
        return this.lastRebase.supply;
    }
    get targetRate() {
        return this.lastRebase.targetRate;
    }
    get rebaseFunctionLowerPercentage() {
        return new bignumber_js_1.BigNumber(this.data.rebaseFunctionLowerPercentage);
    }
    get rebaseFunctionUpperPercentage() {
        return new bignumber_js_1.BigNumber(this.data.rebaseFunctionUpperPercentage);
    }
    get rebaseFunctionGrowth() {
        return new bignumber_js_1.BigNumber(this.data.rebaseFunctionGrowth);
    }
    get rebaseLag() {
        return new bignumber_js_1.BigNumber(this.data.rebaseLag);
    }
    get deviationThreshold() {
        return new bignumber_js_1.BigNumber(this.data.deviationThreshold);
    }
    get minRebaseTimeIntervalSec() {
        return new bignumber_js_1.BigNumber(this.data.minRebaseTimeIntervalSec);
    }
    get rebaseWindowLengthSec() {
        return new bignumber_js_1.BigNumber(this.data.rebaseWindowLengthSec);
    }
    get rebaseWindowOffsetSec() {
        return new bignumber_js_1.BigNumber(this.data.rebaseWindowOffsetSec);
    }
    nextRebaseWindow() {
        const lastRebaseTs = this.lastRebase.timestamp;
        const lastRebaseWindowStart = lastRebaseTs.minus(lastRebaseTs.mod(this.rebaseWindowOffsetSec));
        const nextRebaseWindowStart = lastRebaseWindowStart.plus(this.minRebaseTimeIntervalSec);
        const nextRebaseWindowEnd = nextRebaseWindowStart.plus(this.rebaseWindowLengthSec);
        return [nextRebaseWindowStart, nextRebaseWindowEnd];
    }
    nextRebaseSupply(marketRate, targetRate) {
        const supplyDelta = this.computeSupplyDelta(marketRate, targetRate);
        return this.supply.plus(supplyDelta);
    }
    nextRebasePerc(marketRate, targetRate) {
        const deviation = new bignumber_js_1.BigNumber(marketRate).minus(new bignumber_js_1.BigNumber(targetRate));
        if (deviation.abs().lte(this.deviationThreshold)) {
            return new bignumber_js_1.BigNumber('0');
        }
        const upper = new bignumber_js_1.BigNumber(this.rebaseFunctionUpperPercentage);
        const lower = new bignumber_js_1.BigNumber(this.rebaseFunctionLowerPercentage);
        const growth = new bignumber_js_1.BigNumber(this.rebaseFunctionGrowth);
        const scaling = new bignumber_js_1.BigNumber('32');
        const delta = new bignumber_js_1.BigNumber(marketRate)
            .div(new bignumber_js_1.BigNumber(targetRate))
            .minus(new bignumber_js_1.BigNumber('1'));
        let exp = growth.multipliedBy(delta);
        exp = bignumber_js_1.BigNumber.minimum(new bignumber_js_1.BigNumber('100'), exp);
        exp = bignumber_js_1.BigNumber.maximum(new bignumber_js_1.BigNumber('-100'), exp);
        exp = exp.gte(new bignumber_js_1.BigNumber('0'))
            ? exp
                .multipliedBy(scaling)
                .dp(0, bignumber_js_1.BigNumber.ROUND_FLOOR)
                .div(scaling)
            : exp.multipliedBy(scaling).dp(0, bignumber_js_1.BigNumber.ROUND_CEIL).div(scaling);
        const pow = new bignumber_js_1.BigNumber(Math.pow(2, exp.toNumber()));
        if (pow.isEqualTo(new bignumber_js_1.BigNumber('0'))) {
            return new bignumber_js_1.BigNumber('0');
        }
        const numerator = upper.minus(lower);
        const intermediate = upper.div(lower).div(pow);
        const denominator = new bignumber_js_1.BigNumber('1').minus(intermediate);
        return lower.plus(numerator.div(denominator));
    }
    computeSupplyDelta(marketRate, targetRate) {
        const nextRebasePercentage = this.nextRebasePerc(marketRate, targetRate);
        return this.supply.multipliedBy(nextRebasePercentage);
    }
    // TODO: convert this to binary search
    getSupplyOn(dt) {
        const ts = new bignumber_js_1.BigNumber(dt);
        for (let r = 0; r < this.historicalRebases.length - 1; r++) {
            const r1 = this.historicalRebases[r];
            const r2 = this.historicalRebases[r + 1];
            if (ts.gte(r1.timestamp) && ts.lt(r2.timestamp)) {
                return r1.supply;
            }
        }
        return this.supply;
    }
    loadHistoricalRebases(rebases) {
        for (const rebase of rebases) {
            this.historicalRebases.push(rebase);
        }
        this.historicalRebases = this.historicalRebases.sort((r1, r2) => r1.timestamp.comparedTo(r2.timestamp));
    }
}
exports.default = Policy;
//# sourceMappingURL=Policy.js.map